export function DhamhaAungLanLogo({
    size = 100,
}: {
    size?: number
}) {
    return (
        <>
            <img
                src="/assets/dhamha_aung_lan_logo.png"
                alt="Dhamha Aung Lan Logo"
                width={size}
                height={size}
            />
        </>
    )
}
